import { HasOnComplete, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { ApiParameter, get, post } from "@insite/client-framework/Services/ApiService";

export interface ProductSlangDetailModel {
    ProductId: string;
    ProductNumber: string;
    ProductCategoryPath: string;
    UserEmail: string;
    SlangTermValues: string[];
}

export interface ProductSlangListParameters extends ApiParameter {
    productId?: string;
}

export interface ProductSlangListDetailsModel { }

export async function loadSlangListAPI(
    parameter: ProductSlangListParameters &
        HasOnSuccess<ProductSlangListDetailsModel> &
        HasOnComplete<ProductSlangListDetailsModel>,
) {
    const response = await get<ProductSlangDetailModel>(`/api/v1/GerrieSlangTerm/${parameter.productId}`);
    return response;
}

export async function addSlangsListAPI(params:ProductSlangDetailModel) {
    const response = await post<ProductSlangDetailModel, string>("/api/v1/GerrieSlangTerm", params);
    return response;
}